import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ReorderQuestionOptionsUseCaseInterface } from 'domain/usecases';

export class RemoteReorderQuestionOptions
  implements ReorderQuestionOptionsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: ReorderQuestionOptionsUseCaseInterface.Params,
  ): Promise<ReorderQuestionOptionsUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/reorder`,
      body: params,
      method: 'patch',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
